import { FC, ReactNode, useMemo } from 'react';
import { LegalContextProps, LegalContext } from './legal.context';

interface LegalMainProps extends LegalContextProps {
  children: ReactNode;
}

const LegalMain: FC<LegalMainProps> = ({ children, locationId, documentType }) => {
  const contextValue = useMemo<LegalContextProps>(
    () => ({
      locationId: locationId || '',
      documentType,
    }),
    [locationId, documentType]
  );

  return <LegalContext.Provider value={contextValue}>{children}</LegalContext.Provider>;
};

export default LegalMain;
